// extracted by mini-css-extract-plugin
module.exports = {"mainComponent":"style_mainComponent__n0nTc","mainContent":"style_mainContent__wXl5Z","rightContainer":"style_rightContainer__3mlIU"};